import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=242294bc&scoped=true"
import script from "./CartModal.vue?vue&type=script&lang=ts"
export * from "./CartModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242294bc",
  null
  
)

export default component.exports